import ActionWithPayload from 'moduleBase/reducers/types/ActionWithPayload';
import { CART_NOTIFIER_LOAD_SUCCESS } from 'moduleCartNotifier/constants';
import { StateType } from 'moduleCartNotifier/types/StateType';
import { LoadSuccessPayloadType } from 'moduleCartNotifier/actions/types/LoadSuccessPayloadType';
import {
  ADD_TO_CART, ADD_TO_CART_WITH_FORMAT,
  CART_DELETE_ALL_COMPLETE,
  CART_DELETE_ITEM_COMPLETE,
  CART_PAY_COMPLETE,
  REMOVE_FROM_CART, REMOVE_FROM_CART_WITH_FORMAT,
} from 'moduleCart/constants';
import { PayCompletePayloadType } from 'moduleCart/actions/types/PayCompletePayloadType';
import { DEAL_REPEAT_SUCCESS } from 'modules/deal/constants';

const defaultState = {};

// eslint-disable-next-line default-param-last
const reducerCartNotifier = (state: StateType = defaultState, action: ActionWithPayload): StateType => {
  switch (action.type) {
    case CART_NOTIFIER_LOAD_SUCCESS: {
      const payload = action.payload as LoadSuccessPayloadType;
      return {
        ...state,
        count: payload.count,
      };
    }
    case ADD_TO_CART: {
      return {
        ...state,
        count: state.count + 1,
      };
    }
    case REMOVE_FROM_CART: {
      return {
        ...state,
        count: state.count - 1,
      };
    }
    case ADD_TO_CART_WITH_FORMAT: {
      return {
        ...state,
        count: state.count + 1,
      };
    }
    case REMOVE_FROM_CART_WITH_FORMAT: {
      return {
        ...state,
        count: state.count - 1,
      };
    }
    case CART_DELETE_ITEM_COMPLETE: {
      return {
        ...state,
        count: state.count - 1,
      };
    }
    case CART_DELETE_ALL_COMPLETE: {
      return {
        ...state,
        count: 0,
      };
    }
    case CART_PAY_COMPLETE: {
      const payload = action.payload as PayCompletePayloadType;
      return {
        ...state,
        count: state.count - payload.ids.length,
      };
    }
    case DEAL_REPEAT_SUCCESS: {
      return {
        ...state,
        count: state.count + 1,
      };
    }
    default:
      return state;
  }
};

export { reducerCartNotifier };
